var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlasmaCaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.727 29.5665C117.727 29.5665 117.622 28.713 117.564 27.2145C117.505 25.716 116.556 25.2825 116.556 25.2825L110.88 19.872L109.32 19.1115L104.97 19.209L103.705 18.8115H98.5829L87.9869 18.7365L87.2444 19.209L86.3204 19.74L84.4424 18.492L82.2764 18.144L78.6779 18.06L76.0739 20.58H73.8839L70.1954 18.564L71.2034 18.144L71.2874 16.716L68.4599 13.413L67.3874 13.0215L53.8244 15.651L50.4494 16.074L35.9309 16.0245H18.2309L16.7024 16.2915L15.1919 17.514C15.1919 17.514 11.8514 17.466 8.61291 18.1065C5.37441 18.747 4.14741 22.2585 4.14741 22.2585L4.39941 23.4765L2.71941 23.6445L2.00391 24.3585L2.80341 25.9545L4.18941 25.8705L3.85341 26.748L2.67741 27.1305L2.00541 28.5585L3.34941 29.2305V33.681L5.36691 34.767C5.36691 34.767 7.71591 35.865 7.94391 36.0075C8.17191 36.15 9.39591 37.6065 9.39591 37.6065L10.3169 37.7115C10.3169 37.7115 13.3394 37.0935 14.7434 37.011C16.1459 36.93 17.0384 38.046 17.0384 38.046C17.0384 38.046 25.5839 36.7365 26.5274 36.618C27.4709 36.501 29.7179 36.7155 29.7179 36.7155C29.7179 36.7155 36.9599 37.1895 39.2069 37.467C41.4524 37.7445 43.5914 39.5445 43.5914 39.5445L47.9144 44.1195L49.6214 46.362L52.2794 43.923V42.495L49.1174 38.7165L49.6214 36.6165L54.6599 42.495L57.3479 42.075L62.4704 36.6165C62.4704 36.6165 62.2679 35.4045 62.1854 34.3995C62.1029 33.3945 63.3269 32.097 64.2644 31.65C65.2034 31.203 67.6739 31.755 68.5139 32.1885C69.3539 32.6205 70.2794 34.3485 70.2794 34.3485C70.2794 34.3485 72.6374 33.4485 73.1624 33.4245C73.6874 33.4005 74.6999 34.566 75.0134 35.385C75.3269 36.204 74.4494 38.157 73.8839 39.1665C73.3184 40.176 71.5394 41.4885 71.5394 41.4885L72.2954 42.6645C72.2954 42.6645 72.5474 44.1765 73.1639 44.844C73.7804 45.5115 75.7394 46.3605 75.7394 46.3605L76.9154 45.1845C76.9154 45.1845 78.1094 44.28 78.8744 43.4895C79.6409 42.6975 80.4239 41.0235 80.8664 39.951C81.3104 38.877 82.3289 36.1995 82.3289 36.1995L82.5404 34.8555C82.5404 34.8555 81.1274 34.683 79.7684 34.3515C78.4109 34.02 78.2819 31.899 78.3089 30.825C78.3359 29.7495 80.6279 28.3485 81.9209 27.9885C83.2139 27.6285 85.3814 29.451 85.3814 29.451C85.3814 29.451 89.2394 33.7185 89.7614 34.689C90.2849 35.6595 89.4254 36.285 89.4254 36.285L90.1814 36.873C90.1814 36.873 99.2534 33.654 100.456 33.0795C101.659 32.5035 106.405 32.4345 108.825 32.253C111.246 32.073 114.703 32.01 115.291 32.0025C115.879 31.9935 117.318 31.2765 117.633 30.9105C117.948 30.5445 117.721 29.5665 117.721 29.5665H117.727ZM46.6424 39.2235C45.8069 39.2235 45.1304 38.547 45.1304 37.7115C45.1304 36.876 45.8069 36.1995 46.6424 36.1995C47.4779 36.1995 48.1544 36.876 48.1544 37.7115C48.1544 38.547 47.4779 39.2235 46.6424 39.2235ZM71.8784 32.007C70.7684 32.007 69.8684 31.107 69.8684 29.997C69.8684 28.887 70.7684 27.987 71.8784 27.987C72.9884 27.987 73.8884 28.887 73.8884 29.997C73.8884 31.107 72.9884 32.007 71.8784 32.007Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0811 26.7104L92.8721 29.3984C92.8721 29.3984 94.663 28.4639 96.2875 28.3709C97.912 28.2779 106.197 28.3709 106.197 28.3709L109.839 32.1929",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1669 25.9275C73.1669 25.9275 75.7424 27.2715 76.1339 29.0625C76.5254 30.8535 75.2939 32.0085 75.2939 32.0085C75.2939 32.0085 77.2529 32.814 77.4779 35.445C77.7014 38.076 76.1909 38.916 76.1909 38.916L74.4554 38.1615",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1895 38.916V41.6025",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2988 42.666H73.8888L76.5738 45.5775",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6289 33.078L56.9924 42.135",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8115 30.825L58.974 39.951",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3428 28.8105L61.1338 38.0475",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.745 27.471C15.2222 27.471 15.609 27.0842 15.609 26.607C15.609 26.1298 15.2222 25.743 14.745 25.743C14.2678 25.743 13.881 26.1298 13.881 26.607C13.881 27.0842 14.2678 27.471 14.745 27.471Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1825 25.671C11.6597 25.671 12.0465 25.2842 12.0465 24.807C12.0465 24.3298 11.6597 23.943 11.1825 23.943C10.7053 23.943 10.3185 24.3298 10.3185 24.807C10.3185 25.2842 10.7053 25.671 11.1825 25.671Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1825 29.1975C11.6597 29.1975 12.0465 28.8107 12.0465 28.3335C12.0465 27.8563 11.6597 27.4695 11.1825 27.4695C10.7053 27.4695 10.3185 27.8563 10.3185 28.3335C10.3185 28.8107 10.7053 29.1975 11.1825 29.1975Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6145 25.5075L9.4545 25.9545V27.27L8.6145 27.9885",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7842 25.647C47.7842 25.647 49.9322 25.2975 49.9322 26.445C49.9322 27.5925 47.7842 27.411 47.7842 27.411",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1544 27.2145H64.3484L65.5514 28.278H67.6799L68.7434 27.4215",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9375 28.9785H60.486L61.521 29.9985H64.2645L65.0205 30.4725H68.463",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30.825L62.1885 34.9095",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.229 29.451H104.156C104.156 29.451 102.924 29.4225 102.953 29.9985L102.981 30.5745C102.981 30.5745 102.813 31.218 104.184 31.2465C105.555 31.275 108.831 31.1325 108.831 31.1325",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.738 19.209L115.325 27.186L114.401 28.5015L114.372 29.5665H113.448L112.526 28.8375",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6672 28.2929C87.8453 28.2929 87.9897 28.1486 87.9897 27.9704C87.9897 27.7923 87.8453 27.6479 87.6672 27.6479C87.4891 27.6479 87.3447 27.7923 87.3447 27.9704C87.3447 28.1486 87.4891 28.2929 87.6672 28.2929Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.15 21.924C107.304 21.924 107.43 21.7984 107.43 21.6435C107.43 21.4886 107.304 21.363 107.15 21.363C106.995 21.363 106.869 21.4886 106.869 21.6435C106.869 21.7984 106.995 21.924 107.15 21.924Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M78.877 37.3065C79.0394 37.3065 79.171 37.1749 79.171 37.0125C79.171 36.8501 79.0394 36.7185 78.877 36.7185C78.7146 36.7185 78.583 36.8501 78.583 37.0125C78.583 37.1749 78.7146 37.3065 78.877 37.3065Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9472 16.7175C15.9472 16.7175 16.2832 16.2135 17.9632 16.0455C19.6432 15.8775 26.7817 16.1295 31.9042 16.0455C37.0267 15.9615 48.6157 16.347 51.6397 15.987C54.6637 15.627 64.9087 13.527 64.9087 13.527L67.3912 13.023L68.7712 13.527L71.7112 16.7175L71.2072 18.1455L70.1992 18.5655L72.9622 20.5815H76.0792L78.6832 18.0615C78.6832 18.0615 83.9737 17.8935 85.1497 18.8175L86.3257 19.7415L87.2497 19.5735V18.7335C87.2497 18.7335 103.289 18.8175 104.129 19.0695C104.969 19.3215 106.481 19.2375 106.817 19.1535C107.153 19.0695 110.008 18.9015 110.512 19.4895C111.016 20.0775 116.558 25.284 116.558 25.284C116.558 25.284 117.398 26.124 117.566 27.216C117.734 28.308 117.566 29.232 117.566 29.232C117.566 29.232 118.135 30.072 117.641 30.912C117.148 31.752 115.636 32.004 115.3 32.004C114.964 32.004 108.497 32.088 103.375 32.76C98.2522 33.432 90.1897 36.8745 90.1897 36.8745L89.4337 36.2865C89.4337 36.2865 89.9377 35.7825 89.7697 34.6905C89.6017 33.5985 85.4872 29.568 85.4872 29.568C85.4872 29.568 83.2192 26.628 79.9447 28.728C76.6702 30.828 79.0207 34.0185 79.7767 34.3545C80.5327 34.6905 82.5487 34.8585 82.5487 34.8585C82.5487 34.8585 82.6327 36.0345 81.9607 36.8745C81.2887 37.7145 80.9527 42.669 76.9222 45.189C76.9222 45.189 75.9982 46.281 75.7462 46.365C75.4942 46.449 72.7222 44.769 72.5557 44.181C72.3892 43.593 72.3037 42.669 72.3037 42.669L71.5477 41.493C71.5477 41.493 73.6477 39.897 74.3197 38.469C74.9917 37.041 75.7477 34.8585 73.8997 33.8505C72.0517 32.8425 70.2892 33.9345 70.2892 34.3545C70.2892 34.3545 69.3802 32.6745 68.2387 32.0025C67.0972 31.3305 63.4027 30.9105 62.5627 33.0945L62.1427 34.6065L62.4787 36.6225L57.3562 42.081L54.6682 42.501L49.6297 36.6225L49.1257 38.7225L52.2877 42.501V43.929L50.0497 46.368L43.8352 39.8145C43.8352 39.8145 42.4072 37.9665 39.7207 37.5465C37.0327 37.1265 30.8182 36.5385 27.3757 36.6225C23.9332 36.7065 17.0467 38.0505 17.0467 38.0505C17.0467 38.0505 15.5347 37.2105 15.0307 37.1265C14.5267 37.0425 13.2667 36.9585 12.0067 37.3785C10.7467 37.7985 10.1587 38.0505 9.65471 37.7985C9.15071 37.5465 8.31071 36.1185 7.72271 35.8665C7.13471 35.6145 5.28671 34.6905 4.78271 34.5225C4.27871 34.3545 3.35471 33.6825 3.35471 33.6825V30L4.19471 29.232H2.59871C2.59871 29.232 1.96871 28.728 2.01071 28.56C2.05271 28.392 2.68271 27.132 2.68271 27.132L4.19471 27.09V25.872L2.80871 25.956C2.80871 25.956 2.17421 24.696 2.00921 24.36C1.84421 24.024 2.43071 23.688 2.72471 23.646C3.01871 23.604 4.40471 23.478 4.40471 23.478L4.15271 22.26C4.15271 22.26 5.24471 18.8175 9.40121 17.8935C13.5577 16.9695 15.1957 17.5155 15.1957 17.5155L15.9517 16.7175H15.9472Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9471 16.7175C15.9471 16.7175 19.3056 18.033 25.8006 19.1535C32.2956 20.2725 42.3171 21.393 44.7246 21.2805C47.1321 21.168 52.6191 21.1125 54.2421 21.897C55.8651 22.6815 57.1536 24.8085 57.1536 24.8085H58.2726L58.4961 24.024H63.8151L64.4316 24.8085H67.3986L72.2271 20.046",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0617 20.7615L70.5907 23.967V25.5345H81.2842C81.2842 25.5345 81.8437 22.959 84.4747 22.791C87.1057 22.623 91.0807 26.7105 91.0807 26.7105L94.7752 25.3665C94.7752 25.3665 95.8942 25.086 96.2872 25.086L96.7912 23.736L104.405 21.2235L104.969 19.209",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2872 25.0875L108.493 25.5915L111.236 27.831V29.3415L112.804 30.909H115.771L116.699 31.6545",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8782 32.0086C72.9883 32.0086 73.8882 31.1087 73.8882 29.9986C73.8882 28.8885 72.9883 27.9886 71.8782 27.9886C70.7681 27.9886 69.8682 28.8885 69.8682 29.9986C69.8682 31.1087 70.7681 32.0086 71.8782 32.0086Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6419 39.2236C47.4769 39.2236 48.1539 38.5466 48.1539 37.7116C48.1539 36.8765 47.4769 36.1996 46.6419 36.1996C45.8068 36.1996 45.1299 36.8765 45.1299 37.7116C45.1299 38.5466 45.8068 39.2236 46.6419 39.2236Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1538 24.807L55.2503 25.815L55.0268 27.9885L56.0903 28.8375C56.0903 28.8375 55.9223 30.1815 53.4023 30.7965C50.8823 31.413 48.9518 31.6695 45.1298 31.653C41.3093 31.6365 30.5033 33.2595 27.4238 33.7635C24.3443 34.2675 18.0188 36.4515 14.4908 36.4515C10.9628 36.4515 5.92425 35.8605 3.34875 29.997",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2575 25.1986V27.9886L23.2825 29.0611L22.1065 28.7251L14.437 30.6286L13.9885 31.4685H11.3005L10.9645 30.6286C10.9645 30.6286 9.061 29.9386 8.4445 27.9886H7.549C7.549 27.9886 7.1575 26.5426 7.549 25.4791H8.3335C8.3335 25.4791 8.725 23.1271 10.9645 22.6231V21.7831H13.7635L14.548 22.5675L22.1335 24.1081L23.1505 23.8756L27.256 25.1986H27.2575Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2568 25.1986L28.5723 24.3031",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2568 27.9886L28.5723 28.9786",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19043 29.2306L5.57643 28.7266C5.57643 28.7266 6.66843 33.5131 13.0089 33.2191C13.0089 33.2191 14.3109 34.5211 15.4449 34.3951C16.5789 34.2691 15.1509 33.0511 15.9489 32.3791C16.7469 31.7071 16.7469 33.6811 18.6789 33.5131C20.6109 33.3451 17.9649 32.0101 19.0989 31.5646C20.2329 31.1191 19.8969 32.8411 21.6189 32.6311C23.3409 32.4211 22.1649 31.4701 22.1649 31.4701L34.2159 29.5246L35.3919 29.9986L38.2479 29.6941L39.3399 29.1466L45.1344 28.7266C45.1344 28.7266 47.6124 28.7686 47.7804 26.6266C47.9484 24.4846 45.1344 24.3031 45.1344 24.3031L39.2139 23.9806L38.4159 23.1406L35.2674 22.8046L34.5114 23.3506L22.2084 21.7831C22.2084 21.7831 22.5864 20.4961 21.5784 20.2861C20.5704 20.0761 20.1504 21.4201 19.3104 21.3361C18.4704 21.2521 19.4364 19.7401 18.6384 19.4461C17.8404 19.1521 16.6224 20.5801 15.9504 20.4961C15.2784 20.4121 16.5804 18.9001 15.6144 18.8161C14.6484 18.7321 13.2204 19.8661 13.2204 19.8661C13.2204 19.8661 7.88793 18.9841 5.99793 23.7706L4.40193 23.4766",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.624 36.6196L55.243 29.9986",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0901 22.9606L87.2471 19.5721",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1396 21.7845L96.7911 23.736",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasmaCaster);
export default __webpack_public_path__ + "static/media/Plasma Caster.e91d45b8cc81da754903197aa1bc3600.svg";
export { ForwardRef as ReactComponent };